import type { StudentHistoryMessage } from '../../types/studentHistory';
import type { MessageGroupItem, MessageTimelineItem } from './types';

const normalizeMessageText = (value: string): string => {
  const normalizedValue = value.replace(/\r\n/g, '\n').trim();

  if (normalizedValue.length > 0) {
    return normalizedValue;
  }

  return 'Mensagem sem conteúdo';
};

const toDayKey = (value: string): string => {
  const parsedDate = new Date(value);

  if (Number.isNaN(parsedDate.getTime())) {
    return value.slice(0, 10);
  }

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatMessageDay = (dayKey: string): string => {
  const [year, month, day] = dayKey.split('-').map(Number);

  if (!year || !month || !day) {
    return dayKey;
  }

  const parsedDate = new Date(year, month - 1, day);

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(parsedDate);
};

export const buildTimelineItems = (messages: StudentHistoryMessage[]): MessageTimelineItem[] => {
  if (messages.length === 0) {
    return [];
  }

  const sortedMessages = [...messages]
    .filter((message) => Boolean(message.message_at))
    .sort((leftRow, rightRow) => leftRow.message_at.localeCompare(rightRow.message_at));

  const timelineItems: MessageTimelineItem[] = [];
  let currentDayKey = '';
  let currentGroup: MessageGroupItem | null = null;

  sortedMessages.forEach((message) => {
    const dayKey = toDayKey(message.message_at);
    const normalizedMessage: StudentHistoryMessage = {
      ...message,
      message: normalizeMessageText(message.message ?? ''),
    };

    if (dayKey !== currentDayKey) {
      currentDayKey = dayKey;
      timelineItems.push({
        type: 'day-divider',
        id: `day-${dayKey}`,
        dayKey,
      });
      currentGroup = null;
    }

    if (!currentGroup || currentGroup.messageFlow !== normalizedMessage.message_flow) {
      currentGroup = {
        id: `group-${normalizedMessage.id}`,
        dayKey,
        messageFlow: normalizedMessage.message_flow,
        messages: [normalizedMessage],
      };

      timelineItems.push({
        type: 'group',
        id: currentGroup.id,
        group: currentGroup,
      });

      return;
    }

    currentGroup.messages.push(normalizedMessage);
  });

  return timelineItems;
};
